import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const kombin = (eks) => eks.reduce((acc, [, d]) => acc.flatMap((a) => d.map((x) => [...a, x])), [[]]);

export const VaryantDialog = ({ urun, onClose, onDone }) => {
  const [tanimlar, setTanimlar] = useState([]);
  const [sec, setSec] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/varyant-tanimlari").then((r) => setTanimlar(r.data)); }, []);
  const degis = (tid, v) => setSec((s) => { const l = s[tid] || []; return { ...s, [tid]: l.includes(v) ? l.filter((x) => x !== v) : [...l, v] }; });
  const eks = useMemo(() => tanimlar.filter((t) => sec[t.id]?.length).map((t) => [t.ad, sec[t.id]]), [tanimlar, sec]);
  const liste = eks.length ? kombin(eks) : [];
  const olustur = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/urunler/${urun.id}/varyant-olustur`, { secimler: sec });
      toast.success(`${data.olusan.length} varyant oluşturuldu${data.atlanan.length ? `, ${data.atlanan.length} zaten vardı` : ""}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-2xl max-h-[90vh] overflow-y-auto erp-scroll" data-testid="varyant-dialog">
        <DialogHeader><DialogTitle className="font-head">Varyant oluştur · {urun.kod}</DialogTitle></DialogHeader>
        {tanimlar.length === 0 ? <p className="text-sm text-muted-foreground">Önce <Link to="/varyantlar" className="text-[var(--g1)] hover:underline">Varyantlar</Link> sekmesinden bir varyant tanımı (örn. Renk: Kırmızı, Mavi) ekleyin.</p>
          : tanimlar.map((t) => (
            <div key={t.id} data-testid={`varyant-tanim-${t.ad}`}><div className="text-xs text-muted-foreground mb-2">{t.ad}</div>
              <div className="flex flex-wrap gap-1.5">{t.degerler.map((v) => { const on = sec[t.id]?.includes(v); return (
                <button key={v} type="button" data-testid={`varyant-deger-${t.ad}-${v}`} onClick={() => degis(t.id, v)} className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${on ? "grad-bg text-white border-transparent" : "border-white/15 hover:bg-white/5"}`}>{v}</button>); })}</div></div>))}
        {liste.length > 0 && <div className="rounded-xl bg-white/5 p-3 text-xs space-y-1 max-h-48 overflow-y-auto erp-scroll" data-testid="varyant-onizleme">
          <div className="text-muted-foreground mb-1">{liste.length} ürün oluşacak (reçete, fiyat ve ayarlar ana üründen kopyalanır):</div>
          {liste.slice(0, 50).map((k) => <div key={k.join("-")} className="font-mono">{urun.ad} {k.join(" ")}</div>)}</div>}
        <div className="flex justify-end gap-2"><button onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm hover:bg-white/5">Vazgeç</button>
          <GradButton data-testid="varyant-olustur" disabled={!liste.length || busy} onClick={olustur}>{busy ? "Oluşturuluyor…" : "Oluştur"}</GradButton></div>
      </DialogContent>
    </Dialog>
  );
};
